export default __webpack_public_path__ + "static/media/notifications_blue.2ba23038.svg";